/**
 * Marble Fangs Smart Cart V2 Phase 3
 * Modular complement + option helpers. No Size Advisor coupling.
 * Namespace: window.MfSmartCart
 * Phase 3: dismiss soften, first-paint harden, fail-soft handles.
 */
(function () {
  'use strict';

  var NS = 'MfSmartCart';
  var DISMISS_KEY = 'mf-smart-cart-complement-dismissed-v2';
  var DISMISS_PRODUCT_KEY = 'mf-smart-cart-complement-dismissed-product-v2';
  var ELIG_KEY = 'mf-smart-cart-complement-eligibility-v2';
  var ROOT_SEL = '[data-mf-sc-complement]';

  function prefersReducedMotion() {
    try {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function parseVariants(root) {
    var el = root.querySelector('[data-mf-sc-variants]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function selectedOptions(root) {
    var selects = root.querySelectorAll('[data-mf-sc-option]');
    var opts = [];
    var complete = true;
    selects.forEach(function (sel) {
      var idx = parseInt(sel.getAttribute('data-mf-sc-option-index'), 10) || 0;
      var val = sel.value;
      if (!val) complete = false;
      opts[idx] = val || null;
    });
    return { options: opts, complete: complete };
  }

  function findVariant(variants, options) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < options.length; j++) {
        var key = 'option' + (j + 1);
        if (options[j] == null) continue;
        if (v[key] !== options[j]) {
          match = false;
          break;
        }
      }
      if (match) return v;
    }
    return null;
  }

  function variantsForPartial(variants, options) {
    return variants.filter(function (v) {
      for (var j = 0; j < options.length; j++) {
        if (options[j] == null) continue;
        if (v['option' + (j + 1)] !== options[j]) return false;
      }
      return true;
    });
  }

  function uniqueOptionValues(variants, optionIndex) {
    var key = 'option' + (optionIndex + 1);
    var seen = {};
    var out = [];
    variants.forEach(function (v) {
      var val = v[key];
      if (val != null && !seen[val]) {
        seen[val] = true;
        out.push(val);
      }
    });
    return out;
  }

  function availableValuesForOption(variants, optionIndex, priorOptions) {
    var partial = priorOptions.slice(0, optionIndex);
    var matched = variantsForPartial(variants, partial);
    var values = uniqueOptionValues(matched, optionIndex);
    var availableSet = {};
    matched.forEach(function (v) {
      if (v.available) {
        availableSet[v['option' + (optionIndex + 1)]] = true;
      }
    });
    return { values: values, availableSet: availableSet };
  }

  function updateDependentOptions(root, variants) {
    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-mf-sc-option]'));
    selects.sort(function (a, b) {
      return (
        (parseInt(a.getAttribute('data-mf-sc-option-index'), 10) || 0) -
        (parseInt(b.getAttribute('data-mf-sc-option-index'), 10) || 0)
      );
    });

    var current = selectedOptions(root).options;

    // When option 0 (typically Color) changes, refresh option 1+ availability
    for (var i = 1; i < selects.length; i++) {
      var sel = selects[i];
      var info = availableValuesForOption(variants, i, current);
      var prev = sel.value;
      var name = (sel.getAttribute('data-mf-sc-option-name') || 'option').toLowerCase();
      var placeholder = 'Select ' + name;

      // Rebuild options: keep placeholder, mark unavailable as disabled
      var html = '<option value="" disabled' + (!prev ? ' selected' : '') + '>' + escapeHtml(placeholder) + '</option>';
      var stillValid = false;
      info.values.forEach(function (val) {
        var isAvail = !!info.availableSet[val];
        var selected = prev === val;
        if (selected && isAvail) stillValid = true;
        html +=
          '<option value="' +
          escapeAttr(val) +
          '"' +
          (selected && isAvail ? ' selected' : '') +
          (!isAvail ? ' disabled' : '') +
          '>' +
          escapeHtml(val) +
          (!isAvail ? ' — unavailable' : '') +
          '</option>';
      });
      sel.innerHTML = html;
      if (!stillValid) {
        sel.value = '';
        current[i] = null;
      }
    }
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, '&#39;');
  }

  function setError(root, message) {
    var err = root.querySelector('[data-mf-sc-error]');
    if (err) err.textContent = message || '';
  }

  function syncAddState(root, variants) {
    var addBtn = root.querySelector('[data-mf-sc-add]');
    var priceEl = root.querySelector('[data-mf-sc-price]');
    var imgEl = root.querySelector('[data-mf-sc-image]');
    if (!addBtn) return;

    var sel = selectedOptions(root);
    var variant = sel.complete ? findVariant(variants, sel.options) : null;
    var canAdd = !!(variant && variant.available);

    addBtn.disabled = !canAdd;
    addBtn.setAttribute('aria-disabled', canAdd ? 'false' : 'true');
    addBtn.dataset.variantId = canAdd ? String(variant.id) : '';

    if (variant) {
      if (priceEl && variant.price_formatted) priceEl.textContent = variant.price_formatted;
      if (imgEl && variant.featured_image) {
        imgEl.src = variant.featured_image;
      }
      if (!variant.available) {
        setError(root, 'This option is no longer available.');
      } else {
        setError(root, '');
      }
    } else {
      setError(root, '');
    }
  }

  function onOptionChange(root, variants, changedSelect) {
    var idx = parseInt(changedSelect.getAttribute('data-mf-sc-option-index'), 10) || 0;
    if (idx === 0) {
      updateDependentOptions(root, variants);
    }
    syncAddState(root, variants);
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function addToCart(root, variantId) {
    var addBtn = root.querySelector('[data-mf-sc-add]');
    var cart = getCartDrawer();
    if (!variantId || !window.routes || !routes.cart_add_url) return;

    setError(root, '');
    if (addBtn) {
      addBtn.setAttribute('aria-disabled', 'true');
      addBtn.disabled = true;
      addBtn.classList.add('loading');
    }

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (s) {
          return s.id;
        })
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    } else {
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);
    }

    var config =
      typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(routes.cart_add_url, config)
      .then(function (res) {
        return res.json();
      })
      .then(function (response) {
        if (response.status) {
          setError(root, 'This option is no longer available.');
          syncAddState(root, parseVariants(root));
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'mf-smart-cart',
              productVariantId: variantId,
              cartData: response,
            });
          } catch (e) {
            /* ignore */
          }
        }

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        } else {
          window.location.href = routes.cart_url || '/cart';
        }
      })
      .catch(function () {
        setError(root, 'This option is no longer available.');
        syncAddState(root, parseVariants(root));
      })
      .finally(function () {
        if (addBtn) addBtn.classList.remove('loading');
      });
  }

  // In-memory fallback when sessionStorage is unavailable
  var dismissMemory = false;
  var dismissProductMemory = null;
  // Last eligibility signature: 'empty' | 'ineligible' | 'eligible:<productId>'
  var eligibilityMemory = null;

  function isCartEmpty() {
    var drawer = document.querySelector('cart-drawer');
    var items = document.querySelector('cart-drawer-items');
    return (
      (drawer && drawer.classList.contains('is-empty')) ||
      (items && items.classList.contains('is-empty')) ||
      !document.querySelector('.cart-item')
    );
  }

  /**
   * Dismiss soften rule (Phase 3):
   * Keep sessionStorage dismiss for the same eligible complement within a session.
   * CLEAR dismiss when:
   *   (A) cart becomes empty, OR
   *   (B) complement product identity changes (tee↔hoodie flip — different
   *       data-mf-sc-product-id than the one recorded at dismiss), OR
   *   (C) cart returns from ineligible (both categories / no Also) → single
   *       eligible category after a remove (module reappears).
   * Do NOT clear merely because the drawer closed/reopened with the same
   * tee-only or hoodie-only state.
   */
  function getEligibilitySignature() {
    if (isCartEmpty()) return 'empty';
    var root = document.querySelector(ROOT_SEL);
    if (root) {
      return 'eligible:' + (root.getAttribute('data-mf-sc-product-id') || '');
    }
    return 'ineligible';
  }

  function readStoredEligibility() {
    if (eligibilityMemory != null) return eligibilityMemory;
    try {
      return sessionStorage.getItem(ELIG_KEY);
    } catch (e) {
      return null;
    }
  }

  function rememberEligibility(sig) {
    eligibilityMemory = sig;
    try {
      sessionStorage.setItem(ELIG_KEY, sig);
    } catch (e) {
      /* private mode — memory still applies this tab */
    }
  }

  function getDismissedProductId() {
    if (dismissProductMemory != null && dismissProductMemory !== '') {
      return dismissProductMemory;
    }
    try {
      var stored = sessionStorage.getItem(DISMISS_PRODUCT_KEY);
      if (stored) {
        dismissProductMemory = stored;
        return stored;
      }
    } catch (e) {
      /* ignore */
    }
    return dismissProductMemory;
  }

  function dismiss(root) {
    var productId = (root && root.getAttribute('data-mf-sc-product-id')) || '';
    dismissMemory = true;
    dismissProductMemory = productId;
    resetDetailsExpandedMemory();
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
      if (productId) sessionStorage.setItem(DISMISS_PRODUCT_KEY, productId);
      else sessionStorage.removeItem(DISMISS_PRODUCT_KEY);
    } catch (e) {
      /* private mode — memory flag still applies this tab */
    }
    hideComplement(root);
  }

  function isDismissed() {
    if (dismissMemory) return true;
    try {
      if (sessionStorage.getItem(DISMISS_KEY) === '1') {
        dismissMemory = true;
        return true;
      }
    } catch (e) {
      /* ignore */
    }
    return false;
  }

  function hideComplement(root) {
    if (!root) return;
    root.classList.add('is-dismissed');
    root.setAttribute('hidden', '');
  }

  function clearDismiss() {
    dismissMemory = false;
    dismissProductMemory = null;
    try {
      sessionStorage.removeItem(DISMISS_KEY);
      sessionStorage.removeItem(DISMISS_PRODUCT_KEY);
      // Drop legacy key from pre-fix sessions (v1) so Also can return.
      sessionStorage.removeItem('mf-smart-cart-complement-dismissed');
    } catch (e) {
      /* ignore */
    }
  }

  function softenDismissIfNeeded() {
    var current = getEligibilitySignature();
    var previous = readStoredEligibility();

    if (isDismissed()) {
      if (current === 'empty') {
        // (A) empty cart
        clearDismiss();
      } else if (current.indexOf('eligible:') === 0) {
        var currentPid = current.slice('eligible:'.length);
        var dismissedPid = getDismissedProductId();
        // (B) complement product identity changed (tee↔hoodie flip)
        if (dismissedPid && currentPid && dismissedPid !== currentPid) {
          clearDismiss();
        } else if (previous === 'ineligible') {
          // (C) both/none → single eligible after remove
          clearDismiss();
        }
      }
    }

    rememberEligibility(current);
  }

  // Mobile: remember if the customer manually expanded "Also in the drop"
  // during the current drawer-open interaction. Option changes rebuild
  // <option> nodes (MutationObserver) and cart Section Rendering replaces
  // drawer HTML — both re-run init. Preserve expand across those re-inits.
  // Reset on: dismiss, module absent, fresh complement appearance, mobile
  // drawer open, and PDP ATC (product-form cartUpdate) so first-open after
  // Add to Cart always starts collapsed on viewports <750px.
  var detailsExpandedMemory = false;
  var sawComplement = false;
  var syncingDetails = false;
  var drawerWasActive = false;

  function resetDetailsExpandedMemory() {
    detailsExpandedMemory = false;
  }

  function isDesktopViewport() {
    try {
      return window.matchMedia('(min-width: 750px)').matches;
    } catch (e) {
      return false;
    }
  }

  function syncCollapsedClass(root) {
    if (!root) return;
    var details = root.querySelector('.mf-smart-cart__details');
    // is-collapsed drives dismiss visibility (replaces fragile :has() selector).
    if (!details || !details.open) {
      root.classList.add('is-collapsed');
    } else {
      root.classList.remove('is-collapsed');
    }
  }

  function setDetailsOpenState(details, wantOpen) {
    // Prefer IDL .open (more reliable than attribute alone on WebKit), then
    // mirror attribute so CSS [open] selectors and SSR-replaced HTML stay aligned.
    details.open = !!wantOpen;
    if (wantOpen) details.setAttribute('open', '');
    else details.removeAttribute('open');
  }

  function syncDetailsOpen(root) {
    var details = root.querySelector('.mf-smart-cart__details');
    if (!details) return;
    var desktop = isDesktopViewport();
    // Desktop: always expanded (unchanged).
    // Mobile: collapsed by default; restore open only if the customer expanded
    // it during this drawer interaction (detailsExpandedMemory).
    syncingDetails = true;
    try {
      setDetailsOpenState(details, desktop || detailsExpandedMemory);
    } finally {
      syncCollapsedClass(root);
      // Defer clearing so any sync toggle event sees the guard.
      setTimeout(function () {
        syncingDetails = false;
      }, 0);
    }
  }

  /** Phase 3 first-paint harden: force mobile collapse immediately (memory + DOM). */
  function forceMobileCollapseNow() {
    if (isDesktopViewport()) return;
    resetDetailsExpandedMemory();
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var details = root.querySelector('.mf-smart-cart__details');
      syncingDetails = true;
      try {
        if (details) setDetailsOpenState(details, false);
        root.classList.add('is-collapsed');
      } finally {
        setTimeout(function () {
          syncingDetails = false;
        }, 0);
      }
    }
  }

  function bindDetailsToggle(root) {
    var details = root.querySelector('.mf-smart-cart__details');
    if (!details || details.dataset.mfScToggleBound === '1') return;
    details.dataset.mfScToggleBound = '1';
    details.addEventListener('toggle', function () {
      // Ignore programmatic open/close from syncDetailsOpen.
      if (syncingDetails) return;
      // Track user intent on mobile only. Programmatic desktop open must not
      // poison mobile memory when the breakpoint later changes.
      if (!isDesktopViewport()) {
        detailsExpandedMemory = !!details.open;
      }
      syncCollapsedClass(root);
    });
  }

  function initModule(root) {
    if (!root) return;

    // Always re-apply dismiss (Section Rendering replaces HTML after dismiss).
    if (isDismissed()) {
      hideComplement(root);
      root.dataset.mfScReady = '1';
      return;
    }

    // First-paint harden: on mobile, stamp collapsed class before any open sync
    // so dismiss-visibility CSS and summary chrome match collapsed intent even if
    // a prior open attribute briefly survived section HTML.
    if (!isDesktopViewport()) {
      root.classList.add('is-collapsed');
    }

    if (root.dataset.mfScReady === '1') {
      syncDetailsOpen(root);
      return;
    }
    root.dataset.mfScReady = '1';

    var variants = parseVariants(root);
    root._mfScVariants = variants;

    bindDetailsToggle(root);
    // Mobile: collapse first, then sync (memory may re-open after manual expand).
    if (!isDesktopViewport() && !detailsExpandedMemory) {
      var detailsEarly = root.querySelector('.mf-smart-cart__details');
      if (detailsEarly) {
        syncingDetails = true;
        try {
          setDetailsOpenState(detailsEarly, false);
        } finally {
          syncCollapsedClass(root);
          setTimeout(function () {
            syncingDetails = false;
          }, 0);
        }
      }
    }
    syncDetailsOpen(root);
    syncAddState(root, variants);
  }

  function initAll(scope) {
    // Phase 3: empty cart + identity flip + both→single soften (see softenDismissIfNeeded).
    softenDismissIfNeeded();

    var rootScope = scope || document;
    var modules = rootScope.querySelectorAll
      ? rootScope.querySelectorAll(ROOT_SEL)
      : document.querySelectorAll(ROOT_SEL);
    var hasComplement = modules.length > 0;
    if (!hasComplement && document.querySelector) {
      hasComplement = !!document.querySelector(ROOT_SEL);
    }

    // Fresh appearance (was gone → now present): force mobile collapsed so
    // prior expand-memory cannot open Also on first paint after ATC / eligibility return.
    if (hasComplement && !sawComplement && !isDesktopViewport()) {
      resetDetailsExpandedMemory();
    }

    modules.forEach(initModule);

    // After applying in-scope modules, if none remain in the document the
    // complement is gone — reset so the next appearance starts collapsed.
    if (!document.querySelector(ROOT_SEL)) {
      resetDetailsExpandedMemory();
      sawComplement = false;
    } else {
      sawComplement = true;
    }
  }

  function onMobileDrawerOpened() {
    if (isDesktopViewport()) return;
    forceMobileCollapseNow();
    initAll(document);
  }

  function onMobileDrawerClosed() {
    if (isDesktopViewport()) return;
    // Belt-and-suspenders: drop expand memory on close so the next mobile
    // first-open cannot briefly inherit open from a prior interaction.
    resetDetailsExpandedMemory();
  }

  /**
   * Shopify draft/preview bar (#PBarNextFrameWrapper) is position:fixed over the
   * bottom of the viewport and covers Check out if the drawer is height:100%.
   * Measure it and inset the drawer via --mf-sc-preview-bar (0 when absent).
   */
  var lastPreviewBarPx = -1;

  function syncPreviewBarClearance() {
    var bar = document.getElementById('PBarNextFrameWrapper');
    var h = 0;
    if (bar) {
      var rect = bar.getBoundingClientRect();
      h = Math.max(Math.ceil(rect.height || 0), bar.offsetHeight || 0);
    }
    if (h === lastPreviewBarPx) return;
    lastPreviewBarPx = h;
    document.documentElement.style.setProperty('--mf-sc-preview-bar', h + 'px');
  }

  function bindPreviewBarClearance() {
    syncPreviewBarClearance();
    window.addEventListener('resize', syncPreviewBarClearance);
    // Bar can inject after theme JS
    setTimeout(syncPreviewBarClearance, 100);
    setTimeout(syncPreviewBarClearance, 500);
    setTimeout(syncPreviewBarClearance, 1500);
    if (typeof MutationObserver !== 'undefined') {
      var obs = new MutationObserver(function () {
        syncPreviewBarClearance();
      });
      // Watch for bar mount only — avoid observing documentElement style we write
      obs.observe(document.body, { childList: true, subtree: false });
    }
  }

  function bindDrawerOpenReset() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.mfScOpenBound === '1') return;
    drawer.dataset.mfScOpenBound = '1';
    drawerWasActive = drawer.classList.contains('active');
    if (typeof MutationObserver === 'undefined') return;
    var classObs = new MutationObserver(function () {
      var isActive = drawer.classList.contains('active');
      if (isActive && !drawerWasActive) {
        syncPreviewBarClearance();
        onMobileDrawerOpened();
      } else if (!isActive && drawerWasActive) {
        onMobileDrawerClosed();
      }
      drawerWasActive = isActive;
    });
    classObs.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function onDocumentClick(evt) {
    var dismissBtn = evt.target.closest('[data-mf-sc-dismiss]');
    if (dismissBtn) {
      var root = dismissBtn.closest(ROOT_SEL);
      if (root) {
        evt.preventDefault();
        dismiss(root);
      }
      return;
    }

    var addBtn = evt.target.closest('[data-mf-sc-add]');
    if (addBtn) {
      var rootAdd = addBtn.closest(ROOT_SEL);
      if (!rootAdd || addBtn.disabled || addBtn.getAttribute('aria-disabled') === 'true') return;
      evt.preventDefault();
      var vid = addBtn.dataset.variantId;
      if (vid) addToCart(rootAdd, vid);
    }
  }

  function onDocumentChange(evt) {
    var sel = evt.target.closest && evt.target.closest('[data-mf-sc-option]');
    if (!sel) return;
    var root = sel.closest(ROOT_SEL);
    if (!root) return;
    var variants = root._mfScVariants || parseVariants(root);
    root._mfScVariants = variants;
    onOptionChange(root, variants, sel);
  }

  function bindGlobal() {
    if (window[NS] && window[NS]._bound) return;
    document.addEventListener('click', onDocumentClick);
    document.addEventListener('change', onDocumentChange);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          // PDP Add to Cart: force mobile collapse before/around section paint so
          // the drawer first-open cannot inherit a prior expand. Do not clear on
          // in-drawer qty/remove (cart-items) or complement add — those must keep
          // expand across re-renders once the customer has opened Also.
          if (
            event &&
            event.source === 'product-form' &&
            !isDesktopViewport()
          ) {
            forceMobileCollapseNow();
          }
          // Section HTML may replace drawer nodes; re-init shortly after
          requestAnimationFrame(function () {
            initAll(document);
          });
          setTimeout(function () {
            initAll(document);
          }, 50);
          setTimeout(function () {
            initAll(document);
          }, 250);
        });
      } catch (e) {
        /* optional */
      }
    }

    bindPreviewBarClearance();
    bindDrawerOpenReset();

    // Dawn replaces #CartDrawer via renderContents — observe reattachment
    var drawerHost = document.querySelector('cart-drawer') || document.body;
    if (typeof MutationObserver !== 'undefined' && drawerHost) {
      var obs = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
            initAll(document);
            break;
          }
        }
      });
      obs.observe(drawerHost, { childList: true, subtree: true });
    }

    // Keep mobile collapsed / desktop expanded across resize
    try {
      var mql = window.matchMedia('(min-width: 750px)');
      var onBp = function () {
        initAll(document);
      };
      if (mql.addEventListener) mql.addEventListener('change', onBp);
      else if (mql.addListener) mql.addListener(onBp);
    } catch (e) {
      /* optional */
    }

    // Restore in-memory dismiss from sessionStorage early
    isDismissed();

    window[NS] = window[NS] || {};
    window[NS]._bound = true;
    window[NS].init = initAll;
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    bindGlobal();
    initAll(document);
  });
})();
